export default "__VITE_ASSET__bc62a09a__"